import { api } from '../core';

type ReorderTimelineEntriesResponse = Record<string, never>;

interface ReorderTimelineEntriesProps {
  abortController?: AbortController;
  entryId: string;
  targetEntryId: string;
  position: 'before' | 'after';
}

const timelineEntriesReorderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    reorderTimelineEntries: builder.mutation<ReorderTimelineEntriesResponse, ReorderTimelineEntriesProps>({
      query: ({
        abortController = new AbortController(),
        entryId,
        targetEntryId,
        position
      }: ReorderTimelineEntriesProps) => ({
        url: 'timeline/entries/reorder',
        method: 'POST',
        body: {
          entry_id: entryId,
          target_entry_id: targetEntryId,
          position
        },
        signal: abortController.signal
      }),

      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useReorderTimelineEntriesMutation } = timelineEntriesReorderApi;
